import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setBillingProvider } from '../BrandProvider/actions';
import { STRIPE_ELEMENTS, RECURLY } from '../../constants/providerNames';
import history from '../../history';
import { getBillingProviderSelector } from '../BrandProvider/selectors';

interface Props {
  setBillingProviderValue: (provider: string) => void;
  currentProvider: string;
}

const StripeElementsSetup: React.FC<Props> = ({ setBillingProviderValue, currentProvider }) => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const enableParam = urlParams.get('enable');

    if (enableParam === 'false') {
      console.log('Setting billing provider to RECURLY');
      setBillingProviderValue(RECURLY);
    } else {
      console.log('Setting billing provider to STRIPE_ELEMENTS');
      setBillingProviderValue(STRIPE_ELEMENTS);
    }

    if (currentProvider === STRIPE_ELEMENTS || currentProvider === RECURLY) {
      history.push('/subscriptions');
    }
  }, [setBillingProviderValue, currentProvider]);

  return (
    <div>
      Setting up Stripe Elements...
      <br />
      Current Provider: {currentProvider}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  currentProvider: getBillingProviderSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  setBillingProviderValue: (provider: string) => dispatch(setBillingProvider(provider)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeElementsSetup);
